/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_formbased.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.FormBased= function (_me) {
  // e.g.
  Hafas.ps.sub('/GUI/common/fixedElements/setHeights', Hafas.bind(_me.Controller.FormBased.updateConfigOnResize, _me));
};
